import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import Login from "../Components/Login";

const PrivateRoute = ({ children }) => {
  const { keycloak } = useKeycloak();

  const isLoggedIn = keycloak.authenticated;

  return isLoggedIn ? children : <Login />;
};

export default PrivateRoute;
